import {
  Dialog,
  DialogContent,
  Button,
  Box,
  Typography
} from '@mui/material'

const DisAllowedImagesModal = ({ open, onClose, disAllowedFiles = [] }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="disallowed-images-modal"
      maxWidth="md"
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            minWidth: '400px'
          }
        }
      }}
      disableEscapeKeyDown
      disableBackdropClick
    >
      <DialogContent sx={{ padding: 0 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '0 15px 0 20px'
          }}
        >
          <Typography
            sx={{
              color: '#555',
              fontSize: '13px',
              fontWeight: 'bold',
              textAlign: 'left',
              margin: '10px 0 8px 8px'
            }}
          >
            This file type is not supported.
            <br />
            <br />
            Unable to upload document&nbsp;
            {disAllowedFiles.map((item, index) => (
              <span key={index}>
                "
                {item && item?.name === ''
                  ? 'undefined type'
                  : item?.name}
                "
                {index < disAllowedFiles.length - 1 ? ', ' : '.'}
              </span>
            ))}
            <br />
            <br />
            Only PNG, JPG, JPEG, PDF, or HEIF files are allowed. Excel
            spreadsheets (.xlsx, .xls) are not supported.
          </Typography>
        </Box>
      </DialogContent>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '16px 24px',
          borderTop: '1px solid #e0e0e0'
        }}
      >
        <Button
          variant="contained"
          onClick={onClose}
          sx={{
            width: '80px',
            backgroundColor: '#007bff',
            '&:hover': {
              backgroundColor: '#0056b3'
            },
            textTransform: 'none',
            fontWeight: 'bold'
          }}
        >
          Close
        </Button>
      </Box>
    </Dialog>
  )
}

export default DisAllowedImagesModal